import PeopleScene from "./PeopleScene"
export function People() {
  return <PeopleScene />
}

export default People
